import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { UserDto } from '../../../model/user/user-dto';
import { CheckoutResultPageGuidelines } from '../../../model/checkout-result-page-guidelines';

@Injectable({
  providedIn: 'root'
})
export class SubjectService {

  validationSubject$ = new Subject<UserDto>();
  amountSubject$: Subject<number> = new Subject<number>();
  checkoutResultPageGuidelinesSubject$ = new Subject<CheckoutResultPageGuidelines>();

  constructor() {
  }

  updateAmount(amount: number) {
    this.amountSubject$.next(amount);
  }

  checkoutResultPageGuidelines(checkoutResultPageGuidelines: CheckoutResultPageGuidelines) {
    this.checkoutResultPageGuidelinesSubject$.next(checkoutResultPageGuidelines);
  }

  validate(user: UserDto) {
    this.validationSubject$.next(user);
  }

}
